import React from "react";
import { Outlet, Link } from "react-router-dom";

/** Fully white wordmark on the orange brand surfaces (text, so it stays legible at any size). */
function WhiteWordmark({ className = "" }: { className?: string }) {
  return (
    <Link to="/" aria-label="Soorgaa home" className={`inline-block font-display text-2xl font-bold tracking-tight text-white transition hover:opacity-90 ${className}`}>
      Soorgaa
    </Link>
  );
}

export function AuthLayout() {
  return (
    <div className="min-h-svh flex flex-col lg:flex-row bg-background text-foreground">
      {/* Mobile: compact orange header with the white wordmark */}
      <header className="lg:hidden bg-primary px-4 py-4 pt-[calc(1rem+env(safe-area-inset-top))]">
        <WhiteWordmark />
      </header>

      {/* Desktop: orange brand panel */}
      <div className="hidden lg:flex lg:w-[480px] xl:w-[520px] flex-col justify-between p-10 text-white shrink-0 relative overflow-hidden bg-primary">
        <div
          className="pointer-events-none absolute inset-0 opacity-20"
          style={{
            background:
              "radial-gradient(600px 320px at 20% 15%, rgba(255,255,255,0.4), transparent 55%), radial-gradient(500px 280px at 90% 80%, rgba(0,0,0,0.3), transparent 50%)",
          }}
        />
        <div className="relative z-10">
          <WhiteWordmark className="text-3xl" />
        </div>
        <div className="relative z-10 space-y-4">
          <h1 className="font-display text-4xl font-bold leading-tight tracking-tight">
            Study Smarter.<br />Pass Confidently.
          </h1>
          <p className="font-benton text-white text-sm leading-relaxed max-w-sm">
            Access curated study modules, past exams, and interactive practice designed for Ethiopian university freshmen.
          </p>
          <div className="grid grid-cols-3 gap-2 pt-2">
            {["Curated Modules", "Verified Exams", "AI Quizzes"].map((item) => (
              <div key={item} className="rounded-full px-2.5 py-2 text-xs font-benton font-semibold text-center border border-white/40 bg-white/10">
                {item}
              </div>
            ))}
          </div>
        </div>
        <p className="relative z-10 text-xs text-white font-benton">&copy; 2026 Soorgaa Education</p>
      </div>

      {/* Form */}
      <div className="flex-1 flex flex-col items-center justify-start lg:justify-center p-4 sm:p-8 lg:p-12">
        <div className="w-full max-w-[440px]">
          <div className="bg-card border border-border p-6 sm:p-8 rounded-card shadow-soft">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export function AuthFooterLink({ children }: { children: React.ReactNode }) {
  return <p className="text-center text-xs sm:text-sm font-benton text-muted-foreground mt-5">{children}</p>;
}

export function AuthLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link to={to} className="text-primary font-benton font-semibold hover:underline transition">
      {children}
    </Link>
  );
}
